<script lang="ts" setup>
import { parseISO } from 'date-fns'

import { useCityStore } from '@/store/city/city'

const MONDAY_INDEX = 7
const WEEK_OFFSET = 1

const { isDesktop } = useDevice()

const { cityInfo, sortedWorkingHours } = useCityStore()

// Вычисляем день недели по переданной дате, или ставим понедельник, если дата неверная. После сдвигаем шкалу для российской системы счисления
const weekday =
  (parseISO(cityInfo.current_time).getDay() || MONDAY_INDEX) - WEEK_OFFSET
const selectedDay = sortedWorkingHours[weekday]
const selectedDayText = `c ${selectedDay.start} до ${selectedDay.end}`
</script>

<template>
  <div class="header-working-hours">
    <div
      v-if="!cityInfo.is_active"
      class="header-working-hours__text"
      data-testid="no-work"
    >
      Ресторан закрыт
    </div>

    <div
      v-else-if="!selectedDay.is_working"
      class="header-working-hours__text"
      data-testid="no-work-today"
    >
      Сегодня не работаем
    </div>

    <the-tooltip v-else position-x="center" position-y="bottom" width="160">
      <template #activator>
        <div class="header-working-hours__content" data-testid="work-today">
          <span class="header-working-hours__text">{{ selectedDayText }}</span>

          <the-icon
            v-if="isDesktop"
            class="header-working-hours__icon"
            name="expand-down"
            size="12"
          />
        </div>
      </template>

      <header-working-hours-list
        v-if="isDesktop"
        :sorted-working-tours="sortedWorkingHours"
      />
    </the-tooltip>
  </div>
</template>

<style lang="scss" scoped>
.header-working-hours {
  line-height: 16px;
  pointer-events: none;

  @include media('>=desktop-mini') {
    line-height: 18px;
    pointer-events: auto;
  }

  &__text {
    font-size: 12px;
    font-weight: 600;
    user-select: none;

    @include media('>=desktop') {
      font-size: 14px;
    }
  }

  &__content {
    @include media('>=desktop-mini') {
      display: flex;
      gap: 4px;
      align-items: center;
      cursor: pointer;

      &:hover {
        .header-working-hours__icon {
          transform: rotate(180deg);
        }
      }
    }
  }

  &__icon {
    transition: transform 0.2s ease-in;
  }
}
</style>
